import { PreferencesTab } from '../types';
import { isBloomberg } from '../util/bloomberg';
import { Dayjs } from 'dayjs';
import { dayjs, configureDayjs } from 'util/shared/date';
import { DEV_MODE } from '../config';

configureDayjs();

export const EDITABLE_ACCOUNT_DETAILS = isBloomberg()
  ? []
  : [
      {
        field: 'first_name',
        label: 'First Name',
        type: 'string',
      },
      {
        field: 'last_name',
        label: 'Last Name',
        type: 'string',
      },
      {
        field: 'email',
        label: 'Email',
        type: 'email',
      },
    ];

export const PREFERENCES_LABEL_MAPPING = new Map(
  isBloomberg()
    ? [
        [PreferencesTab.Account, 'Account'],
        [PreferencesTab.Colors, 'Colors'],
        [PreferencesTab.Alerts, 'Alerts'],
      ]
    : [
        [PreferencesTab.Account, 'Account'],
        [PreferencesTab.Colors, 'Colors'],
        [PreferencesTab.Payments, 'Payments'],
        [PreferencesTab.Watchlists, 'Watchlists'],
        [PreferencesTab.Alerts, 'Alerts'],
      ],
);

// putting everything in one place so it can be easily removed later

export type TokenTimeframe = {
  minDate: Dayjs;
  maxDate: Dayjs;
  token: string;
};

export const OH_TOKEN =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJTcG90R2FtbWEiLCJ1c2VyX2lkIjoiY2RhYTkxYmItYWZiMC00ZmI2LWE2ZGQtNjZkNzEzMWRhNDliIiwiaXNfaW5zdGl0dXRpb25hbCI6ZmFsc2UsImlzT3BlbkhvdXNlIjp0cnVlLCJ3cElEIjoxNjYxMSwiZW1haWwiOiJlbmcrYWxwaGFAc3BvdGdhbW1hLmNvbSIsIm1lbWJlcnNoaXBzIjpbIkFscGhhIl0sInJvbGVzIjpbInN1YnNjcmliZXIiXSwidXNlclR5cGUiOjEsIndwVG9rZW4iOnsiYWNjZXNzX3Rva2VuIjoieHNmZTB6b3ljMXRucXFmY2plcmpva2p0b21ycnVqb2tpdGgzMXUxYiIsImV4cGlyZXNfaW4iOjI1OTIwMCwidG9rZW5fdHlwZSI6IkJlYXJlciIsInNjb3BlIjoiYmFzaWMiLCJyZWZyZXNoX3Rva2VuIjoibmY1Y3VqYW5yY2wzcW1yM3h2aGY0b2txb2I3dnFkcDlwajUydzBnbiJ9LCJpYXQiOjE3NjEzMzM5NjcsImV4cCI6MTc2MTg4MzIwMH0.DQxrMfMkRBL3ORSs08HXGVFub9LnfKJM_wKkkCCWTgs';

export const ALPHA_TOKEN_OVERRIDES: TokenTimeframe[] = [
  {
    // TODO: Remove this from DEV_MODE eventually
    minDate: DEV_MODE ? dayjs('2025-10-25 00:00') : dayjs('2025-10-28 00:00'),
    maxDate: dayjs('2025-10-30 23:59'),
    token: OH_TOKEN,
  },
];
